var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpirits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5411_11178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.294 28.5015L81.5251 26.8936H79.5H30.5H28.4749L29.706 28.5015L54.2062 60.5015L55.0002 61.5385L55.7942 60.5015L80.294 28.5015Z",
    fill: "current",
    stroke: "#1D1D1D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7094 46.2159C51.7096 46.2156 51.7098 46.2153 51.71 46.215L51.7094 46.2159ZM50.4708 44.9773C50.4634 44.9815 50.4641 44.9807 50.4718 44.9768L50.4708 44.9773ZM91.5203 3.04511C90.9659 3.59952 89.6354 4.91452 87.7739 6.75444C86.5251 7.98876 85.0373 9.45933 83.3844 11.095C79.2707 15.1657 74.1406 20.2532 69.148 25.2469C64.1564 30.2395 59.2983 35.1423 55.7303 38.8423C53.9477 40.6909 52.4795 42.2472 51.476 43.367C50.9768 43.924 50.5783 44.3889 50.3114 44.7343C50.1822 44.9015 50.059 45.0724 49.9709 45.2273C49.9309 45.2976 49.8656 45.4202 49.8247 45.5686C49.8245 45.5694 49.8243 45.5703 49.824 45.5713C49.805 45.6397 49.6576 46.1719 50.0862 46.6005C50.5148 47.0291 51.047 46.8817 51.1154 46.8627C51.1164 46.8625 51.1173 46.8622 51.1181 46.862C51.2666 46.8212 51.3891 46.7559 51.4595 46.7158C51.6144 46.6278 51.7852 46.5045 51.9524 46.3753C52.2978 46.1084 52.7627 45.7099 53.3197 45.2108C54.4395 44.2072 55.9958 42.739 57.8444 40.9564C61.5444 37.3884 66.4472 32.5303 71.4398 27.5387C76.4335 22.5461 81.521 17.416 85.5917 13.3023C87.2274 11.6494 88.698 10.1616 89.9323 8.91278C91.7722 7.05127 93.0872 5.72084 93.6416 5.16643C94.2446 4.56341 94.1899 3.61893 93.6288 3.05788C93.0678 2.49684 92.1233 2.44209 91.5203 3.04511Z",
    fill: "current",
    stroke: "#1D1D1D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6741 42.5488C64.1612 43.6256 62.9407 44.4026 61.1218 44.6196C59.3179 44.8349 57.0745 44.4671 54.85 43.4074C52.6255 42.3478 50.9263 40.8375 49.9568 39.3012C48.9792 37.752 48.8135 36.3148 49.3264 35.238C49.8393 34.1612 51.0598 33.3843 52.8787 33.1672C54.6826 32.952 56.926 33.3198 59.1505 34.3794C61.375 35.439 63.0742 36.9493 64.0437 38.4857C65.0213 40.0348 65.187 41.472 64.6741 42.5488Z",
    fill: "current",
    stroke: "#1D1D1D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.9376,
    cy: 36.9583,
    r: 1,
    transform: "rotate(25.4707 52.9376 36.9583)",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5143 93.5191H32.4854C32.8519 92.7434 33.653 91.961 34.9366 91.1874C36.7228 90.1109 39.1565 89.2322 41.6619 88.5403C44.1536 87.8521 46.6536 87.3653 48.536 87.0503C49.4757 86.893 50.2582 86.7791 50.8046 86.7047C51.0777 86.6674 51.2916 86.6401 51.4365 86.6222C51.4798 86.6168 51.5169 86.6123 51.5475 86.6086C51.5682 86.6061 51.5859 86.604 51.6007 86.6023L51.6416 86.5975L51.6513 86.5964L51.6534 86.5961L51.6537 86.5961L52.5415 86.4958V85.6024V63.3107V62.9967L52.3619 62.739L20.4157 16.8936H89.5843L57.6377 62.739L57.4582 62.9967V63.3107V85.6024V86.4958L58.3459 86.5961L58.3462 86.5961L58.3484 86.5964L58.3581 86.5975L58.399 86.6023C58.4356 86.6066 58.4907 86.6132 58.5632 86.6222C58.708 86.6401 58.9219 86.6674 59.1951 86.7047C59.7414 86.7791 60.5239 86.893 61.4637 87.0503C63.3461 87.3653 65.8461 87.8521 68.3378 88.5403C70.8432 89.2322 73.2768 90.1109 75.0631 91.1874C76.3466 91.961 77.1478 92.7434 77.5143 93.5191ZM28.5 20.3936H26.6249L27.6696 21.9507L41.7131 42.8835C48.0517 52.3316 61.9483 52.3316 68.2869 42.8835L82.3304 21.9507L83.3751 20.3936H81.5H28.5Z",
    fill: "current",
    stroke: "#1D1D1D",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5411_11178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white",
    transform: "translate(0.5 0.893555)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpirits);
export default __webpack_public_path__ + "static/media/Spirits.2569d370873f67a7f395990f05f0a498.svg";
export { ForwardRef as ReactComponent };